export enum ACTION_STATUS {
  NOTSET = 'NOTSET',
  SUGGESTION = 'SUGGESTION',
  DECIDED = 'DECIDED',
  INPROGRESS = 'INPROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export type ACTION_STATUS_ALLOWED = Exclude<ACTION_STATUS, ACTION_STATUS.NOTSET>;

/**
 * This is the type that we store in Cosmos db, it's not to be used in the application other than when fetching/saving
 * Conversion to this when saving is handled by {@link toBoardsApiSwimlanes}
 * Conversion from this when fetching is handled by {@link toClientActionStatuses}
 */
export enum ACTION_STATUS_CAMEL_CASE {
  NOTSET = 'notSet',
  SUGGESTION = 'suggestion',
  DECIDED = 'decided',
  INPROGRESS = 'inProgress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export type ACTION_STATUS_ALLOWED_CAMEL_CASE = Exclude<ACTION_STATUS_CAMEL_CASE, ACTION_STATUS_CAMEL_CASE.NOTSET>;
